import { BackButton } from "@publicPortal/components/BackButton/BackButton";
import { Grid, Tab, Tabs } from "@mui/material";
import Board from "@publicPortal/components/board/Board";
import ResponsiveAppBar from "@publicPortal/components/responsiveAppBar/ResponsiveAppBar";
import EnforcementAppealsService from "@publicPortal/services/EnforcementAppealsService";
import { IEnforcementAppealDetails } from "@shared/publicportal/contracts/IEnforcementAppealDetails";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { RecordDetailsTabNames } from "@publicPortal/utils/enums";
import Field from "@mirage/components/regularField/Field";

const EnforcementAppeal = () => {
    const service = new EnforcementAppealsService();
    const [appeal, setAppeal] = useState<IEnforcementAppealDetails | null>(null);
    const [loading, setLoading] = useState(false);
    const [cardName, setCardName] = useState<AppealTabs>(RecordDetailsTabNames.Summary);
    const { id } = useParams();

    async function getAppeal() {
        setLoading(true);
        if (!id || isNaN(Number(id))) {
            setLoading(false);
            setAppeal(null);
        } else {
            const appeal: IEnforcementAppealDetails = await service.getEnforcementAppealById(Number(id));
            setLoading(false);
            setAppeal(appeal);
        }
    }

    useEffect(() => {
        getAppeal();
    }, []);

    function getSummaryContent(appeal: IEnforcementAppealDetails) {
        return (
            <Grid container spacing={2}>
                <Grid item xs={12} md={6} lg={6} xl={6}>
                    <Grid item>
                        <Field label="Appeal Name" mode="view" value={appeal.name} contentType="TEXT" />
                    </Grid>
                    <Grid item>
                        <Field label="Appeal Level" mode="view" value={appeal.appealLevel} contentType="TEXT" />
                    </Grid>
                    <Grid item>
                        <Field label="Appellant type" mode="view" value={appeal.apellantType} contentType="TEXT" />
                    </Grid>
                </Grid>
                <Grid item xs={12} md={6} lg={6} xl={6}>
                    <Grid item>
                        <Field label="Date Started" mode="view" value={appeal.dateStarted} contentType="DATE" />
                    </Grid>
                    <Grid item>
                        <Field label="Decision" mode="view" value={appeal.decisionType?.name} contentType="TEXT" />
                    </Grid>
                    <Grid item>
                        <Field label="Appeal Decision Date" mode="view" value={appeal.appealDecisionDate} contentType="DATE" />
                    </Grid>
                </Grid>
            </Grid>
        );
    }

    return (
        <>
            <ResponsiveAppBar />
            <Board headerText={"Enforcement Appeal " + (appeal?.name || "not found")} size="big" loadingHeaderText={loading}>
                <BackButton />
                {appeal ? (
                    <>
                        <Tabs
                            aria-label="Enforcement Appeal Navigation Tabs"
                            sx={{ margin: "2rem 0 3rem 0" }}
                            value={cardName}
                            onChange={(event, newTab: AppealTabs) => setCardName(newTab)}
                        >
                            <Tab key={`${RecordDetailsTabNames.Summary}-key`} disableRipple label={RecordDetailsTabNames.Summary} value={RecordDetailsTabNames.Summary} />;
                        </Tabs>
                        {getSummaryContent(appeal)}
                    </>
                ) : null}
            </Board>
        </>
    );
};

type AppealTabs = RecordDetailsTabNames.Summary;

export default EnforcementAppeal;
